export const enshrineSettingTab = [
  { name: 'myGodList', label: '神明管理', god_type: [1, 2] },
  { name: 'deceasedList', label: '逝者管理', god_type: [3] },
  { name: 'enshrineSetting', label: '一键供奉', god_type: [1, 2, 3] },
];
